export default "__VITE_ASSET__CoF$hYhO__"